import React from 'react'

const PPLText = () => {
  return (
    <div>
      <p>
        <b>Power Pong League</b> was a group project made with Jill Atkins and
        James Blaney. We used JavaScript, React for the front end, and plugged it 
        into a REST API made using Express.js and MongoDB.
      </p>
      <p>
        The app is a tool for tracking ping-pong scores and maintaining a leaderboard
        among a group of players in a casual league. Its features include adding players,
        playing games and saving games to a chronological history, and a live updating leaderboard.
      </p>
      <p>
        This was my first experience of working in a team on a project with version control,
        and I learned a lot about co-ordination and delegation of tasks, communication, and how to avoid or resolve 
        merge conflicts.
      </p>
    </div>
  )
}

export default PPLText